import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAddress } from './selectHouseAddress';

export const selectRegionId = createSelector(selectHouseAddress, address => address[0].id);
